
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/today-deals",
      function () {
        return require("private-next-pages/today-deals/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/today-deals"])
      });
    }
  